import { createRootRoute, createRoute, Outlet } from "@tanstack/react-router";
import HomePage from "../components/HomePage";
import HiringPage from "../components/hiringPage/HiringPage";
import TalentPoolPage from "../components/talent/TalentPoolPage.jsx"; // optional
import AdminLogin from "../components/admin/AdminLogin";
import AdminLayout from "../components/admin/AdminLayout";
import AdminDashboard from "../components/admin/AdminDashboard";
import LeadManagement from "../components/admin/LeadManagement";
import TestimonialManagement from "../components/admin/TestimonialManagement";
import ProjectManagement from "../components/admin/ProjectManagement";
import CaseStudyManagement from "../components/admin/CaseStudyManagement";
import ScheduleManagement from "../components/admin/ScheduleManagement";
import SettingsManagement from "../components/admin/SettingsManagement";
import InternshipManagement from "../components/admin/InternshipManagement";
import CertificateViewer from "../components/internship/CertificateViewer";
import InternshipListing from "../components/internship/InternshipListing";
import TestingDashboard from "../components/TestingDashboard";
import TestimonialSubmission from "../components/testimonials/SubmissionPage";
import InternRegister from "../components/intern/InternRegister";
import InternLogin from "../components/intern/InternLogin";
import InternDashboard from "../components/intern/InternDashboard";
import InternManager from "../components/admin/InternManager";
import AdminKanbanBoard from "../components/admin/AdminKanbanBoard";

const rootRoute = createRootRoute({
  component: () => <>{<Outlet />}</>,
});

const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: HomePage,
});

const aboutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/about",
  component: HomePage,
});

const contactRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/contact",
  component: HomePage,
});

const internshipListingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/internship-certificates",
  component: InternshipListing,
});

const internshipListingAltRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/internshipcertificates",
  component: InternshipListing,
});

const internRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/intern",
  component: InternshipListing,
});

const internsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/interns",
  component: InternshipListing,
});

const internshipRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/internship",
  component: InternshipListing,
});

const hallOfFameRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/halloffame",
  component: InternshipListing,
});

const internshipCertificateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/internship-certificates/$certificateId",
  component: CertificateViewer,
});

const hiringRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/hiring",
  component: HiringPage,
});

const talentPoolRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/talent/$roleId",
  component: TalentPoolPage,
});

const testingDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/testing",
  component: TestingDashboard,
});

const testimonialSubmissionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/submit-testimonial",
  component: TestimonialSubmission,
});

const internRegisterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/intern/register",
  component: InternRegister,
});

const internLoginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/intern/login",
  component: InternLogin,
});

const internDashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/intern/dashboard",
  component: InternDashboard,
});

// Admin routes
const adminLoginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin/login",
  component: AdminLogin,
});

const adminLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin",
  component: AdminLayout,
});

const adminDashboardRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/dashboard",
  component: AdminDashboard,
});

const adminLeadsRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/leads",
  component: LeadManagement,
});

const adminTestimonialsRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/testimonials",
  component: TestimonialManagement,
});

const adminProjectsRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/projects",
  component: ProjectManagement,
});

const adminCaseStudiesRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/case-studies",
  component: CaseStudyManagement,
});

const adminSchedulesRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/schedules",
  component: ScheduleManagement,
});

const adminSettingsRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/settings",
  component: SettingsManagement,
});

const adminInternshipsRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/internships",
  component: InternshipManagement,
});

const adminInternManagerRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/intern-manager",
  component: InternManager,
});

const adminKanbanBoardRoute = createRoute({
  getParentRoute: () => adminLayoutRoute,
  path: "/kanban",
  component: AdminKanbanBoard,
});

export const routeTree = rootRoute.addChildren([
  homeRoute,
  aboutRoute,
  contactRoute,
  internshipListingRoute,
  internshipListingAltRoute,
  internRoute,
  internsRoute,
  internshipRoute,
  hallOfFameRoute,
  internshipCertificateRoute,
  hiringRoute,
  talentPoolRoute,
  testingDashboardRoute,
  testimonialSubmissionRoute,
  internRegisterRoute,
  internLoginRoute,
  internDashboardRoute,
  adminLoginRoute,
  adminLayoutRoute.addChildren([
    adminDashboardRoute,
    adminLeadsRoute,
    adminTestimonialsRoute,
    adminProjectsRoute,
    adminCaseStudiesRoute,
    adminSchedulesRoute,
    adminSettingsRoute,
    adminInternshipsRoute,
    adminInternManagerRoute,
    adminKanbanBoardRoute,
  ]),
]);
